import {
  IUpdate_Query,
  UPDATE_QUERY,
  IToggleLoadingSegmentSlider,
  TOGGLE_LOADING_SEGMENT_SLIDER,
  IUpdateSegmentSlider,
  UPDATE_SEGMENT_SLIDER_DATA,
  IResetSegmentSliderData,
  RESET_SEGMENT_SLIDER,
  IErrorLoadingSegmentSlider,
  ERROR_LOADING_SEGMENT_SLIDER,
} from './types';

export function updateQueryAction(actionData: IUpdate_Query['actionData']): IUpdate_Query {
  return {
    type: UPDATE_QUERY,
    actionData,
  };
}

export function toggleLoadingSegmentSliderAction(
  actionData: IToggleLoadingSegmentSlider['actionData'],
): IToggleLoadingSegmentSlider {
  return {
    type: TOGGLE_LOADING_SEGMENT_SLIDER,
    actionData,
  };
}

export function errorLoadingSegmentSliderAction(
  actionData: IErrorLoadingSegmentSlider['actionData'],
): IErrorLoadingSegmentSlider {
  return {
    type: ERROR_LOADING_SEGMENT_SLIDER,
    actionData,
  };
}

export function updateSegmentSliderAction(
  actionData: IUpdateSegmentSlider['actionData'],
): IUpdateSegmentSlider {
  return {
    type: UPDATE_SEGMENT_SLIDER_DATA,
    actionData,
  };
}

export function resetSegmentSliderDataAction(): IResetSegmentSliderData {
  return {
    type: RESET_SEGMENT_SLIDER,
  };
}
